module.exports = __webpack_public_path__ + "static/media/file-upload-frame.5c08c94c.svg";